import React, { Component } from 'react';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.handleCloseClick = this.handleCloseClick.bind(this);
  }

  handleCloseClick() {
    this.props.closeModal();
  }

  render() {
    return (
      <div
        className="helpText"
        onClick={this.handleClick}
        role="button"
        tabIndex="0"
        style={{ outline: 'none' }}
      >
          <div className="modalContent">
            <div
              className="close"
              onClick={this.handleCloseClick}
              role="button"
              tabIndex="0"
              style={{ outline: 'none' }}
            >
              <span className="icon-remove icon-remove-dims" />
            </div>
            <div className="textHolder">{this.props.content}</div>
          </div>
      </div>
    );
  }
}

export default Modal;
